import { render } from "./AddSignedContractToOrderForm.vue?vue&type=template&id=436b1634"
import script from "./AddSignedContractToOrderForm.vue?vue&type=script&lang=js"
export * from "./AddSignedContractToOrderForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__